/* eslint-disable @typescript-eslint/camelcase */
import { IPriceConfiguration } from '../index'

export default function(
  values: IPriceConfiguration | any,
  objectId,
  calendarId,
) {
  return {
    currency: String(values.currency),
    food: values.food ? 1 : 0,
    food_bb: values.food && values.foodBb ? values.foodBb.toString() : 0,
    food_bb_included: values.food && values.foodBbIncluded ? 1 : 0,
    food_fb: values.food && values.foodFb ? values.foodFb.toString() : 0,
    food_fb_included: values.food && values.foodFbIncluded ? 1 : 0,
    food_hb: values.food && values.foodHb ? values.foodHb.toString() : 0,
    food_hb_included: values.food && values.foodHbIncluded ? 1 : 0,
    id_calendar: Number(calendarId),
    id_object: Number(objectId),
    localtax_days: values.localTaxDays ? values.localTaxDays.toString() : 0,
    kids_price: values.kidsPrice ? 1 : 0,
    localtax: values.localTax ? 1 : 0,
    localtax_adults:
      values.localTax && values.localTaxAdults
        ? values.localTaxAdults.toString()
        : 0,
    localtax_included: values.localTax && values.localTaxIncluded ? 1 : 0,
    localtax_kids:
      values.localTax && values.localTaxKids
        ? values.localTaxKids.toString()
        : 0,
    long_stay_price:
      values.stay && values.stayLongFrom ? Number(values.stayLongFrom) : 0,
    price_per_person: values.pricePerPerson ? 1 : 0,
    restriction_close_at_arrival:
      values.restrictions && values.restrictionCloseAtArrival ? 1 : 0,
    restriction_close_at_departure:
      values.restrictions && values.restrictionCloseAtDeparture ? 1 : 0,
    restriction_exact_stay:
      values.restrictions && values.restrictionExactStay ? 1 : 0,
    restriction_max_before_arrival:
      values.restrictions && values.restrictionMaxBeforeArrival ? 1 : 0,
    restriction_max_stay:
      values.restrictions && values.restrictionMaxStay ? 1 : 0,
    restriction_max_stay_thru:
      values.restrictions && values.restrictionMaxStayThru ? 1 : 0,
    restriction_min_before_arrival:
      values.restrictions && values.restrictionMinBeforeArrival ? 1 : 0,
    restriction_min_stay: values.restrictions && values.restrictionMinStay ? 1 : 0,
    restriction_min_stay_thru:
      values.restrictions && values.restrictionMinThru ? 1 : 0,
    restrictions: values.restrictions ? 1 : 0,
    short_stay_price:
      values.stay && values.stayShortTo ? Number(values.stayShortTo) : 0,
    weekend_price: values.weekendPrice ? 1 : 0,
  }
}
